import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import SigPortfolios from './components/sig-portfolios.vue';
//import TradeChart from './components/com-chart.vue';
import SigPortfolioDetail from './components/portdetail/sig-portfolio-detail.vue';
import SigProfitability from './components/profitability/sig-profitability';
import SigStatistica from './components/statistica/sig-statistica';
import SigProfile from './components/sig-profile';
import SigBlog from './components/blog/sig-blog';
import SigManagment from './components/sig-managment';
import SigCalculator from './components/calculator/sig-calculator';
import SigInvesting from './components/sig-investing';
import SigPersonalArea from './components/personal/sig-personal-area';
import SigChat from './components/sig-chat';
import FullScreen from './components/sig-fullscreen-chart';
import SignalsPage from './components/sig-signals';

export const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', name: 'home', redirect: { name: 'profitability'} },
    { path: '/fullscreen', name: 'chart', component: FullScreen, props: (route) => ({
        chart: route.query.chart
    })},
    { path: '/profitability', name: 'profitability', component: SigProfitability },
    { path: '/statistica', name: 'statistic', component: SigStatistica },
    { path: '/profile', name: 'profile', component: SigProfile },
    { path: '/blog', name: 'blog', component: SigBlog },
    { path: '/managment', name: 'managment', component: SigManagment },
    //{ path: '/calculator', name: 'calculator', component: SigCalculator },
    { path: '/investing', name: 'investing', component: SigInvesting },
    { path: '/portfolios', name: 'portfolios', component: SigPortfolios },
    //{ path: '/chart', name: 'chart', component: TradeChart },
    { path: '/portfolio/:id', name: 'portfolio', component: SigPortfolioDetail },
    { path: '/personal', name: 'personal', component: SigPersonalArea },
    { path: '/chat', name: 'chat', component: SigChat},
    { path: '/signals', name: 'signals', component: SignalsPage}
  ]
})
